(() => {
  function initialize(root = document) {
    root.querySelectorAll('.ah-testimonial-media-wrap').forEach(wrap => {
      const video = wrap.querySelector('video');
      const button = wrap.querySelector('.ah-video-play');
      if (!video || !button || wrap.dataset.initialized) return;
      wrap.dataset.initialized = 'true';
      button.hidden = false;
      button.addEventListener('click', async () => {
        try { await video.play(); } catch { video.controls = true; }
      });
      video.addEventListener('play', () => { button.hidden = true; });
      video.addEventListener('pause', () => { button.hidden = false; });
      video.addEventListener('ended', () => { button.hidden = false; });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
